export default {
  en: {
    API_TOKEN: 'API Token',
    API_TOKEN_TT: 'You account API Token to be used at authenticating with the TrustedForm integration',
    CERT_ID_TAG_MAPPING: 'Cert ID Tag Name',
    CERT_ID_TAG_MAPPING_TT: 'The tag name associated with the Certificate ID received from publishers',
  }
};